import Vue from 'vue'
import VueRouter from 'vue-router'

import RouteReader from '../components/RouteReader.vue'
import StepPersonalData from '../components/StepPersonalData.vue'
import PageNotFound from '../components/404.vue'
import RegistrationConfirmation from '../components/RegistrationConfirmation.vue'
import RegistrationFailed from '../components/RegistrationFailed.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/f/:formHash/', component: RouteReader },
  { path: '/personal-data', component: StepPersonalData },
  { path: '/registration-confirmation', component: RegistrationConfirmation },
  { path: '/registration-failed', component: RegistrationFailed },
  { path: '/404', component: PageNotFound },
  { path: '*', redirect: '/404' }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
